module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "layout"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.showDailyTip && _vm.dailyTip),
      expression: "$store.state.showDailyTip && dailyTip"
    }],
    staticClass: "daily-tip"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("\n                    " + _vm._s(_vm.dailyTip.headline) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.dailyTip.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta"
  }, [_c('div', {
    staticClass: "cta__inner",
    on: {
      "click": function($event) {
        _vm.$store.state.showDailyTip = false
      }
    }
  }, [_vm._v("\n                        Luk besked\n                    ")])])])])]), _vm._v(" "), (_vm.$auth.check()) ? _c('div', [(_vm.$store.state.config.loaded) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('config-bar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('foo')], 1)]) : _c('loader')], 1) : _c('login')], 1) : _c('loader')
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-headline"
  }, [_c('i', {
    staticClass: "fas fa-lightbulb"
  }), _vm._v("\n                    Tips & tricks\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e6fb320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/layout.vue
// module id = 817
// module chunks = 0